<template>
	<core-modal name="j-dialog" :headline="title" width="500" @close="onClose">
		<!-- Wrapper -->
		<div class="p4">
			<!-- Modal Body Text -->
			<div class="flex xs-12 fs4 fw4 ta1 sm-lh125 xs-center mb8">
				<slot></slot>
			</div>

			<!-- For type deletes -->
			<div v-if="type ==='delete'">
				<p class="fs4 fw5 mb1">{{ $t("type_delete_to_confirm") }}</p>
				<j-base-input-text id="deleteText" v-model="input.confirmDelete" />
			</div>

			<!-- Buttons -->
			<div class="flex xs-12 xs-between mt8">
				<j-button type="bordered" class="ml1" @click="onCancel">
					{{
					$t("cancel")
					}}
				</j-button>
				<j-button
					v-if="type === 'delete'"
					v-show="input.confirmDelete === 'DELETE'"
					type="error"
					class="mr1"
					@click="onConfirm"
					action="confirmDelete"
				>
					{{
					$t("delete")
					}}
				</j-button>
			</div>
		</div>
	</core-modal>
</template>

<script>
import JButton from "@/components/JButton/"
import CoreModal from "@/modules/core/components/CoreModal"
import JBaseInputText from "@/components/JBaseInputText"
const initialState = {
	confirmDelete: null
}
export default {
	name: "j-dialog",
	components: {
		JButton,
		CoreModal,
		JBaseInputText
	},
	props: {
		title: "",
		type: {
			type: String,
			validator(value) {
				return value === "normal" || value === "delete"
			}
		}
	},
	data() {
		return {
			input: { ...initialState }
		}
	},
	methods: {
		onConfirm() {
			this.$emit("confirm")
			this.$modal.hide("j-dialog")
		},
		onCancel() {
			this.$emit("cancel")
			this.$modal.hide("j-dialog")
		},
		onClose() {
			this.clearInputs()
			this.$emit("close")
		},
		clearInputs() {
			this.input = { ...initialState }
		}
	}
}
</script>

<style scoped>
.v--modal-overlay {
	background: rgba(0, 0, 0, 0.7);
}
</style>